import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function OpeningHook() {
  return <section className="py-20 md:py-32 px-6 bg-cream" data-id="element-117">
      <div className="max-w-3xl mx-auto" data-id="element-118">
        <FadeIn data-id="element-119">
          <div className="prose prose-lg md:prose-xl text-charcoal" data-id="element-120">
            <p className="leading-relaxed mb-8" data-id="element-121">
              Usted ha pasado toda la vida construyendo un hogar, ahorrando con
              esfuerzo y cuidando de los suyos. Pero,{' '}
              <strong className="font-semibold text-terracotta" data-id="element-122">
                ¿qué pasaría si mañana ocurriera una emergencia y usted no
                pudiera hablar?
              </strong>
            </p>

            <div className="relative pl-8 md:pl-12 py-4 my-12" data-id="element-123">
              <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-gold to-terracotta rounded-full opacity-50" data-id="element-124"></div>
              <p className="font-serif text-2xl md:text-3xl text-sage italic leading-relaxed m-0" data-id="element-125">
                "Ese silencio es el que causa las crisis familiares más
                dolorosas. No por falta de amor, sino por falta de información."
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}